import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import ReceiptIcon from '@mui/icons-material/Receipt';

interface CardPriceBoxProps {
	payment_status: string;
	price: string | number;
	invoice_url: any;
}

export const CardPriceBox = ({ payment_status, price, invoice_url }: CardPriceBoxProps) => {
	const { t } = useTranslation();

	const fileStatusStyles = classNames(
		'flex flex-col min-w-[64px] min-h-[64px] p-1 ml-auto max-xxs:ml-0 rounded-[8px] border font-roboto text-[16px] text-[#343A40] font-[600] leading-normal flex items-center justify-center relative',
		{
			'border-[#E9ECEF] bg-[#F8F9FA]': payment_status === 'stripe_payed' || payment_status === 'invoice_payed',
			'border-primary bg-[#EBFDF9]': payment_status === 'invoice_sent',
		}
	);

	// Function to clean the invoice URL by removing 'undefined/' prefix if present
	const getCleanInvoiceUrl = () => {
		if (!invoice_url?.s3_key) return '';
		
		let s3Key = invoice_url.s3_key;
		// Check if the s3_key starts with 'undefined/' and remove it
		if (s3Key.startsWith('undefined/')) {
			s3Key = s3Key.substring('undefined/'.length);
		}
		
		return `${process.env.REACT_APP_CDN_URL || ''}${s3Key}`;
	};

	return (
		<div className={fileStatusStyles}>
			{(payment_status === 'stripe_payed' || payment_status === 'invoice_payed') && (
				<CheckCircleIcon
					sx={{ color: '#00AB89' }}
					className="absolute top-[-10px] right-[-10px] text-white fill-primary rounded-[8px] p-[2px] bg-white z-20"
				/>
			)}
			€{price}
			{payment_status !== 'invoice_review' && invoice_url && (
				<a
					href={getCleanInvoiceUrl()}
					target="_blank"
					rel="noreferrer"
					className="text-base underline text-dark font-semibold flex items-center gap-1 mt-1"
				>
					<ReceiptIcon fontSize="small" />
					{t('invoice')}
				</a>
			)}
		</div>
	);
};

export default CardPriceBox;
